import React, { useMemo } from "react";
import { motion } from "framer-motion";

const COLORS = ["#38BDF8", "#FDE047", "#F472B6", "#4ADE80", "#FB923C", "#A78BFA"];

// A burst of confetti pieces. Render conditionally when `show` is true.
export const Confetti = ({ show, count = 40 }) => {
  const pieces = useMemo(
    () => Array.from({ length: count }, (_, i) => ({
      id: i,
      x: (Math.random() - 0.5) * 600,
      rot: Math.random() * 720 - 360,
      delay: Math.random() * 0.2,
      color: COLORS[i % COLORS.length],
      size: 8 + Math.random() * 8,
    })),
    [count]
  );
  if (!show) return null;
  return (
    <div className="pointer-events-none fixed inset-0 z-[60] flex items-start justify-center overflow-hidden">
      {pieces.map((p) => (
        <motion.div
          key={p.id}
          initial={{ opacity: 1, x: 0, y: -20, rotate: 0 }}
          animate={{ opacity: [1, 1, 0], x: p.x, y: 700, rotate: p.rot }}
          transition={{ duration: 1.8, delay: p.delay, ease: "easeOut" }}
          style={{ width: p.size, height: p.size, backgroundColor: p.color,
                   borderRadius: p.id % 2 ? "50%" : "3px", position: "absolute", top: 0 }}
        />
      ))}
    </div>
  );
};

export default Confetti;
